import React from 'react';
import AuthLayout from 'layouts/AuthLayout';
import ResetPasswordForm from "./ResetPasswordForm";
import * as qs from "qs";
import {useLocation} from "react-router-dom";

const ResetPasswordPage = () => {
    const location = useLocation();
    const queries = qs.parse(location.search.replace('?',''));
    const token = queries.token;

    return (
        <AuthLayout>
            <div className="reset-password-page">
                <h5>Reset Password</h5>
                <ResetPasswordForm token={token} />
            </div>
        </AuthLayout>
    )
}

export default ResetPasswordPage;